import React, { useEffect, useState, useMemo } from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import './App.css'
import Web3ReactManager from './components/Web3ReactManager'
import Swap from './page/swaps'
import Affiliate from './page/affiliate'
import Landing from './page/affiliate/Landing'
import Header from './components/Header'
import Bonus from './page/bonus'
import Nav from './components/Nav'
import ModalWallet from  "./components/ModalWallet"

function App() {
  return (
    <div>
      <Web3ReactManager>
        <Router>
          <Nav />
          <Switch>
            <Route exact path='/swap' component={Swap} />
            <Route exact path='/swap/:ref' component={Swap} />
            <Route exact path='/home' component={Swap} />
            <Route exact path='/' component={Swap} />
            <Route exact path='/affiliate/:ref' component={Landing} />
            <Route exact path='/affiliateProgarm' component={Affiliate} />
            <Route exact path='/affiliateProgarm/:ref' component={Affiliate} />
            <Route exact path='/bonus' component={Bonus} />
          </Switch>
          <ModalWallet />
        </Router>
      </Web3ReactManager>
    </div>
  )
}

export default App
